export enum MapPinType {
	closed,
	opened,
	detail,
}
